export default "__VITE_ASSET__BmcDamsu__"